import {ObserverAction} from './const';
import {ObserverEvent} from './TasksObserverEvent';

export function groupByEventType<T extends ObserverEvent>(events: T[]) {
  return events.reduce((acc, cur) => {
    if (!acc[cur.action]) acc[cur.action] = [];
    return Object.assign(acc, {[cur.action]: acc[cur.action].concat(cur)});
  }, {} as Record<ObserverAction, T[]>);
}
